import { apiAction } from 'apa/actions'
import * as types from 'customers/actions/types'

export const add = (hour) => (dispatch, getState) =>
  dispatch(apiAction({
    url: '/api/hours/',
    method: 'POST',
    data: hour,
    onSuccess: (hour) => {
      const customer = getState().customers.customer
      customer.hours.push(hour)
      return {
        type: types.ADD_HOUR,
        customer: customer
      }
    }
  }))

export const remove = (hour) => (dispatch, getState) =>
  dispatch(apiAction({
    url: `/api/hours/${hour.id}/`,
    method: 'DELETE',
    onSuccess: (hour) => {
      const customer = getState().customers.customer
      const hourIndex = customer.hours.findIndex(
        item => item.id === hour.id
      )
      customer.hours.splice(hourIndex, 1)
      return {
        type: types.DELETE_HOUR,
        customer: customer
      }
    }
  }))